import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.utiliti.ng";

// Create axios instance with authentication
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for authentication
axiosInstance.interceptors.request.use(
  (config) => {
    const user = localStorage.getItem('user');
    let token = '';
    if (user) {
      try {
        token = JSON.parse(user).token;
      } catch (e) { }
    }
    if (token) {
      config.headers['x-auth-token'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

const referralService = {
  // Get all referrals with pagination and filtering
  getAllReferrals: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/api/referral/admin/referrals', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get referral settings
  getReferralSettings: async () => {
    try {
      const response = await axiosInstance.get('/api/referral/admin/settings');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update referral settings
  updateReferralSettings: async (settings) => {
    try {
      const response = await axiosInstance.put('/api/referral/admin/settings', settings);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get referral statistics
  getReferralStats: async () => {
    try {
      const response = await axiosInstance.get('/api/referral/admin/stats');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Process pending referrals that meet requirements
  processPendingReferrals: async () => {
    try {
      const response = await axiosInstance.post('/api/referral/admin/process-pending');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Validate referral code (public endpoint)
  validateReferralCode: async (referralCode) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/referral/validate`, {
        referralCode
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

export default referralService; 